// extracted by mini-css-extract-plugin
export default {"root":"CompletedHomeworkPill_root__dKDWP","name":"CompletedHomeworkPill_name__s+ZFL","downloadBtn":"CompletedHomeworkPill_downloadBtn__yqRKD index_btn-icon__n2vie"};